export const Colors = {
    beige: "#E1D6CB",
    light: "#F5F5F5",
    white: "#FFF",
    black: "#000",
    gray: "#F5F5F5"
}